export const copy = {
  id: {
    nav: [["beranda", "Beranda"], ["kutipan", "Kutipan"], ["ebook", "Ebook"], ["tentang", "Tentang"]],
    navCta: "Jelajahi Ebook",
    heroEyebrow: "Sales & Marketing Expert · Penulis",
    heroLines: ["Kuasai seni", "menjual dengan", "hati & strategi."],
    heroSub: "Pelajari psikologi penjualan dan strategi pemasaran modern yang benar-benar bekerja, ditulis oleh seorang praktisi, ibu, dan pembelajar seumur hidup.",
    ctaPrimary: "Jelajahi Ebook",
    ctaSecondary: "Chat via WhatsApp",
    heroBadge: "Ibu dari 3 anak",
    heroBadgeSub: "Working mom & penulis",
    scroll: "Gulir",
    waHello: "Halo Kak Rinda, saya ingin bertanya tentang ebook Anda.",
    quotesEyebrow: "Kutipan Pilihan",
    quotesTitle: ["Kata-kata untuk", "langkah besarmu."],
    quotesSub: "Pengingat untuk tetap fokus, gigih, dan berkelas, dalam karier maupun kehidupan. Simpan kutipan favoritmu sebagai gambar untuk story Instagram.",
    saveStory: "Simpan untuk Story",
    dailyLabel: "Kutipan Hari Ini",
    dailyHint: "Kutipan baru setiap hari.",
    ebooksEyebrow: "The Legacy Shelf · Katalog Ebook",
    ebooksTitle: ["Ilmu yang bisa", "kamu pakai hari ini."],
    ebooksSub: "Panduan digital tentang pemasaran, closing, dan pipeline penjualan. Format PDF, langsung dikirim via WhatsApp.",
    buy: "Beli Sekarang",
    format: "PDF · Akses instan",
    bundleSave: "Paling Hemat",
    waBuy: (t) => `Halo Kak Rinda, saya ingin membeli ebook "${t}". Mohon info harga dan cara pembayarannya. Terima kasih!`,
    priceHidden: "Info harga via WhatsApp",
    askWa: "Tanya dulu via WhatsApp",
    pay: {
      creating: { title: "Menyiapkan pembayaran", body: "Mohon tunggu sebentar, halaman pembayaran Midtrans sedang dibuka." },
      checking: { title: "Memeriksa pembayaran", body: "Kami sedang memastikan status pembayaranmu." },
      paid: { title: "Pembayaran berhasil", body: "Terima kasih! Ebook kamu siap diunduh. Simpan nomor pesanan di bawah ini." },
      pending: { title: "Menunggu pembayaran", body: "Selesaikan pembayaran sesuai instruksi Midtrans, lalu tekan Cek Status. Kamu juga bisa kembali ke halaman ini nanti." },
      failed: { title: "Pembayaran gagal", body: "Pembayaran dibatalkan atau kedaluwarsa. Silakan coba lagi." },
      error: { title: "Terjadi kendala", body: "Pembayaran belum bisa diproses saat ini. Coba lagi sebentar atau hubungi kami via WhatsApp." },
      orderLabel: "No. pesanan",
      download: "Unduh Ebook",
      recheck: "Cek Status",
      askFile: "Minta file via WhatsApp",
      help: "Bantuan via WhatsApp",
      wa: (t, id) => `Halo Kak Rinda, saya sudah membeli ebook "${t}" (No. pesanan: ${id}). Mohon bantuannya.`,
    },
    aboutEyebrow: "Tentang Penulis",
    aboutTitle: ["Seorang ibu.", "Seorang profesional."],
    bio: "Penulis adalah seorang Ibu dengan 3 anak yang menjalani peran ganda sebagai seorang working mom (ibu bekerja). Di tengah kesibukan mengelola karir profesional dan mengurus rumah tangga, penulis mendedikasikan tulisan ini sebagai warisan pemikiran dan panduan hidup bagi ketiga anaknya tercinta di masa depan.",
    pills: ["Ibu dari 3 anak", "Working mom", "Sales & Marketing"],
    dedication: "Untuk ketiga buah hatiku.",
    footerTitle: ["Siap menulis", "babak barumu?"],
    footerSub: "Tanyakan ebook yang paling cocok untukmu, langsung lewat WhatsApp.",
    footerCta: "Hubungi via WhatsApp",
    rights: "Hak cipta dilindungi.",
    marquee: ["Psikologi Penjualan", "Closing Strategy", "Marketing Mastery", "Sales Pipeline", "Warisan Pemikiran", "Pasti Bisa"],
  },
  en: {
    nav: [["beranda", "Home"], ["kutipan", "Quotes"], ["ebook", "Ebooks"], ["tentang", "About"]],
    navCta: "Explore Ebooks",
    heroEyebrow: "Sales & Marketing Expert · Author",
    heroLines: ["Master the art", "of selling with", "heart & strategy."],
    heroSub: "Learn the sales psychology and modern marketing strategies that actually work, written by a practitioner, a mother, and a lifelong learner.",
    ctaPrimary: "Explore Ebooks",
    ctaSecondary: "Chat on WhatsApp",
    heroBadge: "Mother of three",
    heroBadgeSub: "Working mom & author",
    scroll: "Scroll",
    waHello: "Hi Rinda, I'd like to ask about your ebooks.",
    quotesEyebrow: "Selected Quotes",
    quotesTitle: ["Words for your", "biggest steps."],
    quotesSub: "Reminders to stay focused, persistent and classy, in your career and in life. Save your favorite quote as an image for your Instagram story.",
    saveStory: "Save for Story",
    dailyLabel: "Quote of the Day",
    dailyHint: "A new quote every day.",
    ebooksEyebrow: "The Legacy Shelf · Ebook Catalog",
    ebooksTitle: ["Knowledge you can", "use today."],
    ebooksSub: "Digital guides on marketing, closing and sales pipelines. PDF format, delivered straight to your WhatsApp.",
    buy: "Get Access",
    format: "PDF · Instant access",
    bundleSave: "Best Value",
    waBuy: (t) => `Hi Rinda, I'd like to get the ebook "${t}". Could you share the price and payment details? Thank you!`,
    priceHidden: "Price info via WhatsApp",
    askWa: "Ask first on WhatsApp",
    pay: {
      creating: { title: "Preparing payment", body: "Please wait a moment while the Midtrans payment page opens." },
      checking: { title: "Checking payment", body: "We're confirming your payment status." },
      paid: { title: "Payment successful", body: "Thank you! Your ebook is ready to download. Keep the order number below." },
      pending: { title: "Awaiting payment", body: "Complete the payment following the Midtrans instructions, then tap Check Status. You can also come back to this page later." },
      failed: { title: "Payment failed", body: "The payment was cancelled or expired. Please try again." },
      error: { title: "Something went wrong", body: "We couldn't process the payment right now. Try again shortly or contact us on WhatsApp." },
      orderLabel: "Order no.",
      download: "Download Ebook",
      recheck: "Check Status",
      askFile: "Request file on WhatsApp",
      help: "Help on WhatsApp",
      wa: (t, id) => `Hi Rinda, I bought the ebook "${t}" (Order no: ${id}). I need some help.`,
    },
    aboutEyebrow: "About the Author",
    aboutTitle: ["A mother.", "A professional."],
    bio: "The author is a mother of three who lives a dual role as a working mom. Amid the demands of a professional career and running a household, she dedicates this writing as a legacy of thought and a life guide for her three beloved children in the future.",
    pills: ["Mother of three", "Working mom", "Sales & Marketing"],
    dedication: "For my three beloved children.",
    footerTitle: ["Ready to write", "your next chapter?"],
    footerSub: "Ask which ebook fits you best, directly on WhatsApp.",
    footerCta: "Contact on WhatsApp",
    rights: "All rights reserved.",
    marquee: ["Sales Psychology", "Closing Strategy", "Marketing Mastery", "Sales Pipeline", "A Legacy of Thought", "You Can Do It"],
  },
};

export const quotes = [
  { tag: { id: "Kegigihan", en: "Grit" }, id: "Dunia ini tidak kekurangan orang pintar, tapi kekurangan orang yang gigih. Ingat satu hal: Kalau orang lain bisa sukses, kamu pun PASTI BISA!", en: "The world is not short of smart people, but of persistent ones. Remember one thing: if others can succeed, you SURELY CAN too!" },
  { tag: { id: "Masa Depan", en: "Future" }, id: "Masa depanmu terlalu mahal jika ditukar dengan kegalauan hari ini. Kejar prestasimu, maka cinta yang berkelas akan datang menghampirimu", en: "Your future is too precious to trade for today's heartache. Chase your achievements, and a love with true class will come to you." },
  { tag: { id: "Karier", en: "Career" }, id: "Setiap langkah kecil yang kamu ambil untuk belajar dan mengejar karier hari ini adalah batu bata yang sedang menyusun istana masa depanmu", en: "Every small step you take today to learn and chase your career is a brick building the palace of your future." },
  { tag: { id: "Fokus", en: "Focus" }, id: "Jika seseorang membuatmu kehilangan fokus untuk belajar dan berkembang, itu adalah tanda bahwa dia adalah batu sandungan, bukan masa depan", en: "If someone makes you lose focus on learning and growing, that is a sign they are a stumbling block, not your future." },
  { tag: { id: "Keyakinan", en: "Belief" }, id: "Setiap kali kamu merasa ragu dengan kemampuanmu, lihatlah mereka yang sudah berhasil. Mereka memiliki waktu 24 jam yang sama denganmu, jadi tidak ada alasan untuk bilang tidak bisa.", en: "Whenever you doubt your abilities, look at those who have succeeded. They have the same 24 hours as you, so there is no reason to say you can't." },
  { tag: { id: "Kemauan", en: "Willpower" }, id: "Keberhasilan bukan milik mereka yang berbakat sejak lahir, melainkan milik mereka yang punya kemauan keras untuk terus mencoba sampai berhasil.", en: "Success does not belong to those born talented, but to those with the fierce will to keep trying until they succeed." },
  { tag: { id: "Prestasi", en: "Achievement" }, id: "Saat kamu sibuk memperbaiki diri dan mengejar prestasi, kamu sedang mengundang masa depan yang jauh lebih terhormat dan berkelas.", en: "While you are busy improving yourself and chasing achievements, you are inviting a far more honorable and classy future." },
];

export const ebooks = [
  {
    slug: "pasti-bisa", vol: "01", title: "Kalau orang lain bisa, kamu pun PASTI BISA!",
    tag: { id: "Motivasi", en: "Motivation" },
    sub: { id: "Membangun keyakinan diri dan kegigihan untuk meraih prestasi, selangkah demi selangkah.", en: "Build self-belief and persistence to reach your achievements, step by step." },
    points: { id: ["Mengatasi rasa ragu pada diri sendiri", "Membangun kebiasaan gigih", "Belajar dari mereka yang berhasil"], en: ["Overcoming self-doubt", "Building persistent habits", "Learning from those who succeeded"] },
    cover: ["#16213A", "#0A0F1C"], ink: "#E5C158",
  },
  {
    slug: "jualan-tanpa-bakat", vol: "02", title: "Jualan tanpa modal bakat",
    tag: { id: "Penjualan", en: "Sales" },
    sub: { id: "Panduan berjualan untuk siapa saja, karena menjual adalah keterampilan yang bisa dipelajari.", en: "A selling guide for anyone, because selling is a skill that can be learned." },
    points: { id: ["Dasar psikologi pembeli", "Cara memulai percakapan jualan", "Teknik closing yang sederhana"], en: ["Buyer psychology basics", "Starting a sales conversation", "Simple closing techniques"] },
    cover: ["#2A1420", "#12080D"], ink: "#F0C9A8",
  },
  {
    slug: "karir-atau-kurir-cinta", vol: "03", title: "Kejar Karir atau Kurir Cinta!",
    tag: { id: "Karier", en: "Career" },
    sub: { id: "Tetap fokus pada masa depan dan prestasi, tanpa kehilangan arah karena urusan hati.", en: "Stay focused on your future and achievements, without losing direction over matters of the heart." },
    points: { id: ["Menjaga fokus belajar & berkembang", "Mengenali batu sandungan", "Menyusun rencana karier"], en: ["Keeping focus on growth", "Recognizing stumbling blocks", "Planning your career"] },
    cover: ["#E9E1CF", "#C9BB9C"], ink: "#1A2238", light: true,
  },
];
